(function () {
  var CONFIG_BY_SOURCE_HANDLE = {
    'mysheepi-home-nackenkissen': {
      addonHandle: 'home-kopfkissen-set',
      heading: 'Wähle Dein Schlaf-Setup',
      cardTitle: 'Mach Dein Schlaf-Setup komplett',
      description: 'Kissen, passender Premiumbezug und Kissenspray – perfekt aufeinander abgestimmt.',
      items: ['1× HOME Nackenkissen', '1× Premium Kissenbezug', '1× Kissenspray'],
      containsSourceProduct: true
    },
    'mysheepi-home-kopfkissen': {
      addonHandle: 'home-kopfkissen-set',
      heading: 'Wähle Dein Schlaf-Setup',
      cardTitle: 'Mach Dein Schlaf-Setup komplett',
      description: 'Kissen, passender Premiumbezug und Kissenspray – perfekt aufeinander abgestimmt.',
      items: ['1× HOME Nackenkissen', '1× Premium Kissenbezug', '1× Kissenspray'],
      containsSourceProduct: true
    },
    'home-pro-kopfkissen': {
      addonHandle: 'home-pro-spar-set',
      heading: 'Wähle Dein Schlaf-Setup',
      cardTitle: 'Das komplette Kühlschlaf-System',
      description: 'Kühlendes Kopfkissen und passende Bettdecke für angenehmere Nächte.',
      items: ['1× HOME Pro Kopfkissen', '1× HOME Pro Bettdecke'],
      containsSourceProduct: true
    },
    'home-bettdecke': {
      addonHandle: 'home-bestseller-set',
      heading: 'Wähle Dein Schlaf-Setup',
      cardTitle: 'Das HOME Bestseller Set',
      description: 'Bettdecke, ergonomisches Nackenkissen und passender Premiumbezug – perfekt kombiniert.',
      items: ['1× HOME Bettdecke', '1× HOME Nackenkissen', '1× Premium Kissenbezug'],
      containsSourceProduct: true
    },
    'home-pro-bettdecke': {
      addonHandle: 'home-pro-spar-set',
      heading: 'Wähle Dein Schlaf-Setup',
      cardTitle: 'Das komplette Kühlschlaf-System',
      description: 'Kühlende Bettdecke und ergonomisches Kopfkissen für angenehmere Nächte.',
      items: ['1× HOME Pro Bettdecke', '1× HOME Pro Kopfkissen'],
      containsSourceProduct: true
    },
    'travel-reisekissen-in-wolkenweiss': {
      addonHandle: 'travel-reisekissen-set',
      heading: 'Wähle Dein Reise-Setup',
      cardTitle: 'Komfortabel schlafen – überall',
      description: 'Reisekissen, passender Bezug und wasserdichte Tasche in einem Set.',
      items: ['1× TRAVEL Reisekissen', '1× Premium Kissenbezug', '1× TRAVELBAG'],
      containsSourceProduct: true
    },
    'mysheepi-seidenschlafmaske': {
      addonHandle: 'home-seide-set',
      heading: 'Passendes Seiden-Set mitbestellen',
      containsSourceProduct: true,
      defaultTargetOptionKeywords: ['seidenmaske']
    },
    'ergonomisches-sitzkissen': {
      addonHandle: 'sitzkissen-set',
      heading: 'Passendes Sitzkissen-Set mitbestellen',
      containsSourceProduct: true
    },
    'ergonomisches-rueckenstuetzkissen': {
      addonHandle: 'sitzkissen-set',
      heading: 'Passendes Sitzkissen-Set mitbestellen',
      containsSourceProduct: true
    },
    'mysheepi-kissenspray': {
      addonHandle: 'home-kopfkissen-set',
      heading: 'HOME Nackenkissen Set mitbestellen',
      containsSourceProduct: true,
      syncTargetOptionKeywords: ['kissenspray']
    },
    travelbag: {
      addonHandle: 'travel-reisekissen-in-wolkenweiss',
      heading: 'TRAVEL Kissen mitbestellen',
      containsSourceProduct: false
    },
    kuschelmantel: {
      addonHandle: 'home-kopfkissen-set',
      heading: 'HOME Nackenkissen Set mitbestellen',
      containsSourceProduct: false
    }
  };

  var HIDDEN_OPTION_VALUES = ['flieder'];
  var currentProduct = window.midaSetProduct || {};
  var sourceHandle = currentProduct.handle || '';
  var config = CONFIG_BY_SOURCE_HANDLE[sourceHandle];
  var productData = null;
  var productRequest = null;
  var mounted = false;

  if (!config) return;

  function replacesSourceProduct() {
    return config.containsSourceProduct === true;
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace('weiß', 'weiss')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function handleize(value) {
    return normalize(value).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function formatMoney(cents) {
    var amount = Math.floor((Number(cents) || 0) / 100);

    try {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount).replace(/\u00A0/g, ' ').trim() + '€';
    } catch (e) {
      return Math.floor(amount) + '€';
    }
  }

  function getDiscountPercent(variant) {
    var price = Number(variant && variant.price) || 0;
    var compareAtPrice = Number(variant && variant.compare_at_price) || 0;

    if (!price || compareAtPrice <= price) return 0;
    return Math.round((1 - price / compareAtPrice) * 100);
  }

  function normalizeSizeLabel(value) {
    var match = String(value || '').match(/(\d{1,3})\s*[xX×]\s*(\d{1,3})/);
    return match ? match[1] + 'x' + match[2] : '';
  }

  function isSizeOption(name) {
    var value = handleize(name);
    return value.indexOf('size') !== -1 || value.indexOf('grosse') !== -1 || value.indexOf('groesse') !== -1 || value.indexOf('masse') !== -1 || value.indexOf('grose') !== -1;
  }

  function getOptionName(product, index) {
    var option = product.options && product.options[index];
    return typeof option === 'string' ? option : option && option.name ? option.name : '';
  }

  function isSizeOptionIndex(product, optionIndex) {
    if (isSizeOption(getOptionName(product, optionIndex))) return true;

    return (product.variants || []).some(function (variant) {
      return !!normalizeSizeLabel(variant.options && variant.options[optionIndex]);
    });
  }

  function getOptionKind(name) {
    var text = handleize(name);
    if (text.indexOf('duft') !== -1 || text.indexOf('spray') !== -1) return 'scent';
    if (text.indexOf('farbe') !== -1 || text.indexOf('color') !== -1 || text.indexOf('colour') !== -1) return 'color';
    if (isSizeOption(text)) return 'size';
    return 'generic';
  }

  function isHiddenOptionValue(value) {
    return HIDDEN_OPTION_VALUES.indexOf(handleize(value)) !== -1;
  }

  function cleanText(el) {
    if (!el) return '';

    var clone = el.cloneNode(true);
    clone.querySelectorAll('.label-unavailable, .visually-hidden').forEach(function (hidden) {
      hidden.remove();
    });

    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function getProductForm() {
    return (
      document.querySelector('product-form form.product-form-submit') ||
      document.querySelector('form.product-form-submit') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function getInsertionTarget() {
    var form = getProductForm();
    if (!form) return null;

    var buttons = form.querySelector('.product-form__buttons');
    var buyWrapper = form.querySelector('.buy-button__wrapper') || document.querySelector('.buy-button__wrapper');

    if (buttons) return { form: form, reference: buttons, parent: buttons.parentNode };
    if (buyWrapper) return { form: form, reference: buyWrapper, parent: buyWrapper.parentNode };

    return null;
  }

  function getProduct() {
    if (productRequest) return productRequest;

    productRequest = fetch(window.location.origin + '/products/' + config.addonHandle + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product fetch failed: ' + response.status);
        return response.json();
      })
      .then(function (product) {
        productData = product;
        return product;
      })
      .catch(function () {
        return null;
      });

    return productRequest;
  }

  function getImageSrc(image, width) {
    var src = '';

    if (typeof image === 'string') {
      src = image;
    } else if (image) {
      src = image.src || image.url || '';
    }

    if (!src && productData && productData.featured_image) {
      src = typeof productData.featured_image === 'string' ? productData.featured_image : productData.featured_image.src;
    }

    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;

    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function getImageAlt(image, product) {
    return image && image.alt ? image.alt : product.title;
  }

  function openImagePreview(src, alt) {
    if (!src) return;

    var existing = document.querySelector('[data-mida-image-modal]');
    if (existing) existing.remove();

    var modal = document.createElement('div');
    modal.className = 'mida-image-modal';
    modal.setAttribute('data-mida-image-modal', '');
    modal.innerHTML =
      '<button type="button" class="mida-image-modal__backdrop" data-mida-image-close></button>' +
      '<div class="mida-image-modal__dialog">' +
        '<button type="button" class="mida-image-modal__close" data-mida-image-close>×</button>' +
        '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(alt || '') + '">' +
      '</div>';

    document.body.appendChild(modal);
    document.documentElement.classList.add('mida-image-modal-open');
  }

  function isVisibleVariant(variant) {
    if (!variant || variant.available === false) return false;

    return (variant.options || []).every(function (value) {
      return !isHiddenOptionValue(value);
    });
  }

  function getMainSelectedVariant() {
    var variantSelects = document.querySelector('variant-selects');
    var json = variantSelects && variantSelects.querySelector('script[type="application/json"]');
    var form = getProductForm();
    var selectedId = form && new FormData(form).get('id');

    if (!json) return null;

    try {
      var variants = JSON.parse(json.textContent) || [];
      var byId = variants.find(function (variant) {
        return String(variant.id) === String(selectedId);
      });

      if (byId) return byId;

      var pickedOptions = [];

      Array.from(variantSelects.querySelectorAll('fieldset.product-form__input')).forEach(function (fieldset) {
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked) pickedOptions.push(checked.value);
      });

      return variants.find(function (variant) {
        var options = variant.options || [variant.option1, variant.option2, variant.option3];

        return pickedOptions.every(function (value, index) {
          return options[index] === value;
        });
      }) || null;
    } catch (e) {
      return null;
    }
  }

  function getMainSelections() {
    var selections = [];
    var variantSelects = document.querySelector('variant-selects');
    var selectedVariant = getMainSelectedVariant();

    if (variantSelects) {
      Array.from(variantSelects.querySelectorAll('fieldset.product-form__input')).forEach(function (fieldset) {
        var legend = fieldset.querySelector('legend');
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        var label = checked && fieldset.querySelector('label[for="' + checked.id + '"]');
        var value = checked && (checked.value || cleanText(label));

        if (value) {
          selections.push({
            name: cleanText(legend),
            value: value,
            kind: getOptionKind(cleanText(legend))
          });
        }
      });

      Array.from(variantSelects.querySelectorAll('select')).forEach(function (select) {
        var label = select.id ? document.querySelector('label[for="' + select.id + '"]') : null;
        if (select.value) {
          selections.push({
            name: cleanText(label),
            value: select.value,
            kind: getOptionKind(cleanText(label))
          });
        }
      });
    }

    if (selectedVariant) {
      (selectedVariant.options || [selectedVariant.option1, selectedVariant.option2, selectedVariant.option3]).forEach(function (value) {
        if (value) {
          selections.push({
            name: '',
            value: value,
            kind: normalizeSizeLabel(value) ? 'size' : 'generic'
          });
        }
      });
    }

    return selections;
  }

  function getMainSizeLabels() {
    var labels = [];

    getMainSelections().forEach(function (selection) {
      var size = normalizeSizeLabel(selection.value);
      if (size && labels.indexOf(size) === -1) labels.push(size);
    });

    return labels;
  }

  function targetOptionShouldSync(product, optionIndex) {
    if (isSizeOptionIndex(product, optionIndex)) {
      var mainSizeLabels = getMainSizeLabels();
      var hasMatchingSize = (product.variants || []).some(function (variant) {
        var targetSize = normalizeSizeLabel(variant.options && variant.options[optionIndex]);
        return targetSize && mainSizeLabels.indexOf(targetSize) !== -1;
      });

      if (hasMatchingSize) return true;
    }

    return targetOptionMatchesKeywords(product, optionIndex, config.syncTargetOptionKeywords || []);
  }

  function targetOptionMatchesKeywords(product, optionIndex, keywords) {
    var optionHandle = handleize(getOptionName(product, optionIndex));

    return keywords.some(function (keyword) {
      return optionHandle.indexOf(handleize(keyword)) !== -1;
    });
  }

  function getSyncedOptionValue(product, optionIndex) {
    var targetValues = {};
    var targetKind = getOptionKind(getOptionName(product, optionIndex));
    var sizeLabels = getMainSizeLabels();

    (product.variants || []).forEach(function (variant) {
      var value = variant.options && variant.options[optionIndex];
      if (value) targetValues[handleize(value)] = value;
    });

    if (isSizeOptionIndex(product, optionIndex) && sizeLabels.length) {
      var sizeMatch = Object.keys(targetValues).find(function (key) {
        return sizeLabels.indexOf(normalizeSizeLabel(targetValues[key])) !== -1;
      });
      return sizeMatch ? targetValues[sizeMatch] : null;
    }

    var selections = getMainSelections();
    var exact = selections.find(function (selection) {
      return targetValues[handleize(selection.value)] && (selection.kind === targetKind || targetKind === 'generic' || selection.kind === 'generic');
    });

    if (exact) return targetValues[handleize(exact.value)];

    exact = selections.find(function (selection) {
      return targetValues[handleize(selection.value)];
    });

    return exact ? targetValues[handleize(exact.value)] : null;
  }

  function getSelectedAddonOptions(card, product) {
    var options = [null, null, null];

    (product.options || []).forEach(function (_, index) {
      if (targetOptionShouldSync(product, index)) {
        options[index] = getSyncedOptionValue(product, index);
      }
    });

    card.querySelectorAll('[data-addon-option-input]:checked').forEach(function (input) {
      var index = Number(input.getAttribute('data-option-index')) - 1;
      if (index >= 0) options[index] = input.value;
    });

    return options;
  }

  function variantMatches(variant, selectedOptions) {
    if (!isVisibleVariant(variant)) return false;

    var options = variant.options || [variant.option1, variant.option2, variant.option3];

    return selectedOptions.every(function (selectedOption, index) {
      if (!selectedOption) return true;
      return handleize(options[index]) === handleize(selectedOption);
    });
  }

  function findBestVariant(product, card) {
    var variants = (product.variants || []).filter(isVisibleVariant);
    var selectedOptions = getSelectedAddonOptions(card, product);

    return (
      variants.find(function (variant) {
        return variantMatches(variant, selectedOptions);
      }) ||
      variants.find(function (variant) {
        return variantMatches(variant, selectedOptions.map(function (value, index) {
          return targetOptionShouldSync(product, index) ? null : value;
        }));
      }) ||
      variants[0]
    );
  }

  function syncDropdownsToVariant(card, product, variant) {
    if (!variant) return;

    card.querySelectorAll('[data-addon-dropdown]').forEach(function (dropdown) {
      var input = dropdown.querySelector('[data-addon-option-input]:checked');
      var current = dropdown.querySelector('[data-addon-dropdown-current]');
      if (input && current) current.textContent = input.getAttribute('data-addon-display-value') || input.value;
    });
  }

  function requiredOptionsMissing(card) {
    if (!card) return false;

    return Array.from(card.querySelectorAll('[data-addon-dropdown-required]')).some(function (dropdown) {
      return !dropdown.querySelector('[data-addon-option-input]:checked');
    });
  }

  function updateDropdownRequiredStates(card, showMissing) {
    var hasMissing = false;

    if (!card) return false;

    card.querySelectorAll('[data-addon-dropdown-required]').forEach(function (dropdown) {
      var isMissing = !dropdown.querySelector('[data-addon-option-input]:checked');
      hasMissing = hasMissing || isMissing;
      dropdown.classList.toggle('is-missing', showMissing && isMissing);
    });

    card.classList.toggle('has-missing-options', showMissing && hasMissing);
    return hasMissing;
  }

  function updateAddonButtons(card) {
    var addOnlyButton = card && card.querySelector('[data-addon-add-only]');
    var isMissing = requiredOptionsMissing(card);

    if (!addOnlyButton) return;

    if (!addOnlyButton.classList.contains('loading')) addOnlyButton.disabled = false;
    addOnlyButton.setAttribute('aria-disabled', isMissing ? 'true' : 'false');
  }

  function syncAddonSelectionState(card) {
    if (!card) return;

    var checkbox = card.querySelector('[data-addon-checkbox]');
    var toggle = card.querySelector('[data-addon-toggle]');
    var isSelected = Boolean(checkbox && checkbox.checked && !checkbox.disabled);

    card.classList.toggle('is-selected', isSelected);
    if (toggle) toggle.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

    var wrapper = card.closest('[data-mida-pdp-addon]');
    var singleChoice = wrapper && wrapper.querySelector('[data-addon-single]');
    if (singleChoice) {
      singleChoice.classList.toggle('is-selected', !isSelected);
      singleChoice.setAttribute('aria-pressed', isSelected ? 'false' : 'true');
    }

    updatePrimaryButtonCopy(isSelected);
  }

  function updatePrimaryButtonCopy(bundleSelected) {
    var form = getProductForm();
    var button = form && form.querySelector('[type="submit"], button[name="add"]');
    var label = button && button.querySelector('span:not(.sold-out-message)');

    if (!label) return;
    if (!label.dataset.midaOriginalText) label.dataset.midaOriginalText = label.textContent.trim();

    label.textContent = bundleSelected
      ? 'Als komplettes Set in den Warenkorb'
      : label.dataset.midaOriginalText;
  }

  function updateSingleProductPrice(wrapper) {
    var priceElement = wrapper && wrapper.querySelector('[data-main-product-price]');
    var selectedVariant = getMainSelectedVariant();
    var price = selectedVariant && selectedVariant.price != null ? selectedVariant.price : currentProduct.price;

    if (priceElement && price != null) priceElement.textContent = formatMoney(price);
  }

  function setAddonSelected(card, selected) {
    if (!card) return false;

    var checkbox = card.querySelector('[data-addon-checkbox]');
    if (!checkbox || checkbox.disabled) return false;

    if (checkbox.checked === selected) {
      syncAddonSelectionState(card);
      return checkbox.checked;
    }

    checkbox.checked = selected;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));

    return checkbox.checked;
  }

  function validateRequiredOptions(card) {
    var hasMissing = updateDropdownRequiredStates(card, true);
    var firstMissingToggle = card && card.querySelector('[data-addon-dropdown-required].is-missing [data-addon-dropdown-toggle]');

    updateAddonButtons(card);

    if (firstMissingToggle) firstMissingToggle.focus();

    return !hasMissing;
  }

  function updateSyncedNote(card, product, variant) {
    var note = card.querySelector('[data-mida-addon-note]');
    if (!note) return;

    var synced = [];

    (product.options || []).forEach(function (_, index) {
      if (!targetOptionShouldSync(product, index)) return;
      var value = getSyncedOptionValue(product, index);
      if (value) synced.push(value);
    });

    note.textContent = synced.join(' · ');
    note.hidden = !synced.length;
  }

  function syncCardVariant(card) {
    if (!productData || !card) return;

    var variant = findBestVariant(productData, card);
    if (!variant) return;

    var checkbox = card.querySelector('[data-addon-checkbox]');
    if (checkbox) {
      checkbox.value = String(variant.id);
      checkbox.setAttribute('data-addon-variant-id', String(variant.id));
      checkbox.disabled = variant.available === false;
    }

    var price = card.querySelector('[data-addon-price]');
    if (price) price.textContent = formatMoney(variant.price);

    var compare = card.querySelector('[data-addon-compare]');
    if (compare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.hidden = false;
        compare.textContent = formatMoney(variant.compare_at_price);
      } else {
        compare.hidden = true;
        compare.textContent = '';
      }
    }

    var discount = card.querySelector('[data-addon-discount]');
    var discountPercent = getDiscountPercent(variant);
    if (discount) {
      discount.hidden = !discountPercent;
      discount.textContent = discountPercent ? discountPercent + '% Set-Vorteil' : '';
    }

    var image = card.querySelector('.pdp-addons__image');
    var variantImage = variant.featured_image || (variant.featured_media && variant.featured_media.preview_image) || productData.featured_image;

    if (image && variantImage) {
      image.src = getImageSrc(variantImage, 280);
      image.alt = getImageAlt(variantImage, productData);
    }

    var imageButton = card.querySelector('[data-mida-image-preview]');
    if (imageButton && variantImage) {
      imageButton.setAttribute('data-mida-image-src', getImageSrc(variantImage, 900));
      imageButton.setAttribute('data-mida-image-alt', getImageAlt(variantImage, productData));
    }

    syncDropdownsToVariant(card, productData, variant);
    updateSyncedNote(card, productData, variant);
    updateDropdownRequiredStates(card, card.classList.contains('has-missing-options'));
    updateAddonButtons(card);
    syncAddonSelectionState(card);
    updateSingleProductPrice(card.closest('[data-mida-pdp-addon]'));
  }

  function getDropdownLabel(optionName) {
    var kind = getOptionKind(optionName);
    if (kind === 'scent') return 'Duft auswählen';
    if (kind === 'size') return 'Größe auswählen';
    if (kind === 'color') return 'Farbe auswählen';
    return 'Auswählen';
  }

  function getDropdownCurrentText(product, optionIndex, value) {
    return value;
  }

  function getDropdownPlaceholderText(product, optionIndex) {
    var optionName = getOptionName(product, optionIndex);
    var kind = getOptionKind(optionName);
    return kind === 'size' ? 'Größe' : kind === 'scent' ? 'Duft' : kind === 'color' ? 'Farbe' : 'Auswählen';
  }

  function getInitialSelectedVariant(product, visibleVariants) {
    var keywords = config.defaultTargetOptionKeywords || [];
    var preferredOptions = [null, null, null];

    if (!keywords.length) return visibleVariants[0];

    (product.options || []).forEach(function (_, index) {
      if (!targetOptionMatchesKeywords(product, index, keywords)) return;
      preferredOptions[index] = getSyncedOptionValue(product, index);
    });

    if (!preferredOptions.some(Boolean)) return visibleVariants[0];

    return visibleVariants.find(function (variant) {
      return variantMatches(variant, preferredOptions);
    }) || visibleVariants[0];
  }

  function buildOptionDropdown(product, visibleVariants, optionIndex, selectedVariant, idBase) {
    var optionName = getOptionName(product, optionIndex);
    if (!optionName || optionName === 'Title' || targetOptionShouldSync(product, optionIndex)) return '';

    var rendered = {};
    var values = [];

    visibleVariants.forEach(function (variant) {
      var value = variant.options && variant.options[optionIndex];
      var key = handleize(value);

      if (!value || value === 'Default Title' || rendered[key] || isHiddenOptionValue(value)) return;

      rendered[key] = true;
      values.push(value);
    });

    if (values.length <= 1) return '';

    var dropdownLabel = getDropdownLabel(optionName);
    var placeholder = getDropdownPlaceholderText(product, optionIndex);

    return '' +
      '<fieldset class="pdp-addons__option">' +
        '<legend class="pdp-addons__option-label">' + escapeHtml(dropdownLabel) + '</legend>' +
        '<div class="pdp-addons__dropdown" data-addon-dropdown data-addon-dropdown-required data-addon-placeholder="' + escapeHtml(placeholder) + '">' +
          '<button class="pdp-addons__dropdown-toggle" type="button" data-addon-dropdown-toggle aria-expanded="false" aria-label="' + escapeHtml(dropdownLabel) + '">' +
            '<span data-addon-dropdown-current>' + escapeHtml(placeholder) + '</span>' +
          '</button>' +
          '<div class="pdp-addons__choice-row" data-addon-dropdown-menu>' +
            values.map(function (value) {
              var id = idBase + '-Option' + (optionIndex + 1) + '-' + handleize(value);
              var displayValue = getDropdownCurrentText(product, optionIndex, value);

              return '' +
                '<span class="pdp-addons__choice">' +
                  '<input id="' + escapeHtml(id) + '" class="pdp-addons__choice-input" type="radio" name="' + escapeHtml(idBase + '-Option' + (optionIndex + 1)) + '" value="' + escapeHtml(value) + '" data-addon-option-input data-option-index="' + (optionIndex + 1) + '" data-addon-display-value="' + escapeHtml(displayValue) + '">' +
                  '<label class="pdp-addons__choice-label" for="' + escapeHtml(id) + '">' + escapeHtml(value) + '</label>' +
                '</span>';
            }).join('') +
          '</div>' +
        '</div>' +
        '<span class="pdp-addons__option-error" data-addon-option-error>Bitte auswählen</span>' +
      '</fieldset>';
  }

  function buildAddon(product) {
    var visibleVariants = (product.variants || []).filter(isVisibleVariant);
    if (!visibleVariants.length) return null;

    var selectedVariant = visibleVariants[0];
    selectedVariant = getInitialSelectedVariant(product, visibleVariants);
    var image = selectedVariant.featured_image || product.featured_image;
    var idBase = 'MidaPdpAddon-' + product.id;
    var replaceMainProduct = replacesSourceProduct();

    var optionsHtml = (product.options || []).map(function (_, index) {
      return buildOptionDropdown(product, visibleVariants, index, selectedVariant, idBase);
    }).join('');
    var hasOptionControls = optionsHtml.length > 0;

    var wrapper = document.createElement('div');
    wrapper.className = 'pdp-addons mida-pdp-addon mida-pdp-addon--bundle-choice' + (replaceMainProduct ? ' mida-pdp-addon--replace-main' : '') + (hasOptionControls ? '' : ' mida-pdp-addon--no-options');
    wrapper.setAttribute('data-pdp-addons', '');
    wrapper.setAttribute('data-mida-pdp-addon', '');

    wrapper.innerHTML =
      '<div class="pdp-addons__header">' +
        '<p class="pdp-addons__eyebrow">' + escapeHtml(config.heading || 'Passend dazu mitbestellen') + '</p>' +
      '</div>' +
      '<div class="pdp-addons__list">' +
        '<button type="button" class="pdp-addons__single is-selected" data-addon-single aria-pressed="true">' +
          '<span class="pdp-addons__radio" aria-hidden="true"></span>' +
          '<span class="pdp-addons__single-copy"><strong>Nur ' + escapeHtml(currentProduct.title || 'das Kissen') + '</strong><small>Einzelprodukt</small></span>' +
          '<strong class="pdp-addons__single-price" data-main-product-price>' + formatMoney(currentProduct.price) + '</strong>' +
        '</button>' +
        '<div class="pdp-addons__item" data-pdp-addon-card data-product-id="' + escapeHtml(product.id) + '">' +
          '<input id="' + escapeHtml(idBase) + '" class="pdp-addons__checkbox" type="checkbox" value="' + escapeHtml(selectedVariant.id) + '" data-addon-checkbox data-addon-variant-id="' + escapeHtml(selectedVariant.id) + '" data-addon-product-title="' + escapeHtml(product.title) + '">' +
          '<button type="button" class="pdp-addons__toggle" data-addon-toggle aria-pressed="false" aria-label="' + escapeHtml(product.title) + ' hinzufügen"></button>' +
          '<button type="button" class="pdp-addons__media" data-mida-image-preview data-mida-image-src="' + escapeHtml(getImageSrc(image, 900)) + '" data-mida-image-alt="' + escapeHtml(getImageAlt(image, product)) + '">' +
            '<img class="pdp-addons__image" src="' + escapeHtml(getImageSrc(image, 280)) + '" alt="' + escapeHtml(getImageAlt(image, product)) + '" width="124" height="124" loading="lazy">' +
          '</button>' +
          '<div class="pdp-addons__content">' +
            '<div class="pdp-addons__topline">' +
              '<span class="pdp-addons__recommended">Empfohlen</span>' +
              '<label class="pdp-addons__title" for="' + escapeHtml(idBase) + '">' + escapeHtml(config.cardTitle || product.title) + '</label>' +
              '<span class="pdp-addons__price-row">' +
                '<span class="pdp-addons__price" data-addon-price>' + formatMoney(selectedVariant.price) + '</span>' +
                (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price ? '<s class="pdp-addons__compare" data-addon-compare>' + formatMoney(selectedVariant.compare_at_price) + '</s>' : '<s class="pdp-addons__compare" data-addon-compare hidden></s>') +
                '<span class="pdp-addons__discount" data-addon-discount' + (getDiscountPercent(selectedVariant) ? '' : ' hidden') + '>' + (getDiscountPercent(selectedVariant) ? getDiscountPercent(selectedVariant) + '% Set-Vorteil' : '') + '</span>' +
              '</span>' +
            '</div>' +
            '<p class="pdp-addons__description">' + escapeHtml(config.description || '') + '</p>' +
            '<ul class="pdp-addons__contents">' + (config.items || []).map(function (item) { return '<li>' + escapeHtml(item) + '</li>'; }).join('') + '</ul>' +
            '<div class="mida-addon-match-note" data-mida-addon-note hidden></div>' +
            '<div class="mida-addon-controls-row">' +
              '<div class="pdp-addons__options">' + optionsHtml + '</div>' +
              '<a class="pdp-addons__details" href="/products/' + config.addonHandle + '">Produkt ansehen</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    return wrapper;
  }

  function getMainVariantId(form) {
    var selectedVariant = getMainSelectedVariant();
    if (selectedVariant && selectedVariant.id) return selectedVariant.id;

    return new FormData(form).get('id');
  }

  function getCartAddUrl() {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return /\.js(\?|#|$)/.test(url) ? url : url.replace(/\/$/, '') + '.js';
  }

  function setLoadingState(button, isLoading) {
    if (!button) return;

    var spinner = button.querySelector('.loading__spinner');

    button.disabled = isLoading;
    button.classList.toggle('loading', isLoading);

    if (isLoading) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }

    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function submitCartItems(items, button) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    setLoadingState(button, true);

    var payload = {
      items: items
    };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      payload.sections_url = window.location.pathname;

      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        if (typeof cart.renderContents === 'function') cart.renderContents(response);
        if (typeof cart.open === 'function') cart.open();

        window.dispatchEvent(new Event('cart-update'));
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        setLoadingState(button, false);
      });

    return true;
  }

  function addAddonOnly(card, button, quantity) {
    if (!validateRequiredOptions(card)) return false;

    syncCardVariant(card);

    var checkbox = card.querySelector('[data-addon-checkbox]');
    var addonId = checkbox && checkbox.getAttribute('data-addon-variant-id');
    var addonQuantity = Math.max(1, Number(quantity) || 1);

    if (!addonId) return false;

    return submitCartItems([
      { id: Number(addonId), quantity: addonQuantity }
    ], button);
  }

  function addWithAddon(form, card) {
    if (!validateRequiredOptions(card)) return false;

    syncCardVariant(card);

    var checkbox = card.querySelector('[data-addon-checkbox]');
    var addonId = checkbox && checkbox.getAttribute('data-addon-variant-id');
    var mainId = getMainVariantId(form);
    var quantity = Number(new FormData(form).get('quantity')) || 1;
    var submitButton = form.querySelector('[type="submit"], button[name="add"]');

    if (!mainId || !addonId) return false;

    return submitCartItems([
      { id: Number(mainId), quantity: Math.max(1, quantity) },
      { id: Number(addonId), quantity: 1, properties: { '_Add-on': 'true' } }
    ], submitButton);
  }

  function bindSubmitInterceptor(form) {
    if (!form || form.dataset.midaPdpAddonSubmitBound === 'true') return;

    form.dataset.midaPdpAddonSubmitBound = 'true';

    form.addEventListener(
      'submit',
      function (event) {
        var card = form.querySelector('[data-mida-pdp-addon] [data-pdp-addon-card]');
        var checkbox = card && card.querySelector('[data-addon-checkbox]');

        if (!card || !checkbox || !checkbox.checked || checkbox.disabled) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (replacesSourceProduct()) {
          addAddonOnly(card, form.querySelector('[type="submit"], button[name="add"]'), Number(new FormData(form).get('quantity')) || 1);
        } else {
          addWithAddon(form, card);
        }
      },
      true
    );
  }

  function bindAddonEvents(root) {
    if (!root || root.dataset.midaPdpAddonBound === 'true') return;

    root.dataset.midaPdpAddonBound = 'true';

    root.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;

        var imagePreview = target.closest('[data-mida-image-preview]');
        var singleChoice = target.closest('[data-addon-single]');
        var toggle = target.closest('[data-addon-toggle]');
        var addOnlyButton = target.closest('[data-addon-add-only]');
        var dropdownToggle = target.closest('[data-addon-dropdown-toggle]');
        var card = target.closest('[data-pdp-addon-card]');

        if (singleChoice) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          var bundleCard = root.querySelector('[data-pdp-addon-card]');
          if (bundleCard) setAddonSelected(bundleCard, false);
          return;
        }

        if (imagePreview) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          openImagePreview(
            imagePreview.getAttribute('data-mida-image-src'),
            imagePreview.getAttribute('data-mida-image-alt')
          );
          return;
        }

        if (addOnlyButton) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          card = addOnlyButton.closest('[data-pdp-addon-card]');
          if (card) addAddonOnly(card, addOnlyButton);
          return;
        }

        if (toggle) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          card = toggle.closest('[data-pdp-addon-card]');
          var checkbox = card && card.querySelector('[data-addon-checkbox]');
          if (!checkbox || checkbox.disabled) return;

          setAddonSelected(card, !checkbox.checked);
          return;
        }

        if (dropdownToggle) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          var dropdown = dropdownToggle.closest('[data-addon-dropdown]');
          if (!dropdown) return;

          root.querySelectorAll('[data-addon-dropdown].is-open').forEach(function (openDropdown) {
            if (openDropdown === dropdown) return;

            openDropdown.classList.remove('is-open');
            var openToggle = openDropdown.querySelector('[data-addon-dropdown-toggle]');
            if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
          });

          var shouldOpen = !dropdown.classList.contains('is-open');
          dropdown.classList.toggle('is-open', shouldOpen);
          dropdownToggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
          return;
        }

        if (
          card &&
          !card.querySelector('[data-addon-dropdown]') &&
          !target.closest('a, button, input, [data-mida-image-preview]')
        ) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          setAddonSelected(card, true);
          return;
        }

        if (card && !target.closest('a, button, input, label, [data-addon-dropdown], [data-mida-image-preview]')) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          var cardToggle = card.querySelector('[data-addon-toggle]');
          if (cardToggle) cardToggle.click();
        }
      },
      true
    );

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var checkbox = target.closest('[data-addon-checkbox]');
      if (checkbox) {
        var checkboxCard = checkbox.closest('[data-pdp-addon-card]');

        syncAddonSelectionState(checkboxCard);

        syncCardVariant(checkboxCard);
        return;
      }

      var input = target.closest('[data-addon-option-input]');
      if (!input) return;

      var dropdown = input.closest('[data-addon-dropdown]');
      var current = dropdown && dropdown.querySelector('[data-addon-dropdown-current]');
      var card = input.closest('[data-pdp-addon-card]');

      if (current) current.textContent = input.getAttribute('data-addon-display-value') || input.value;

      if (dropdown) {
        dropdown.classList.remove('is-open');

        var dropdownToggle = dropdown.querySelector('[data-addon-dropdown-toggle]');
        if (dropdownToggle) dropdownToggle.setAttribute('aria-expanded', 'false');
      }

      syncCardVariant(card);
      setAddonSelected(card, true);
    });
  }

  function hideOtherAddonsAfterMount() {
    document.querySelectorAll('[data-pdp-addons]:not([data-mida-pdp-addon])').forEach(function (addons) {
      addons.hidden = true;
      addons.classList.add('mida-pdp-addon-original-addons');
    });
  }

  function mount() {
    if (mounted) return;

    var target = getInsertionTarget();
    if (!target || !target.parent || !target.reference) return;

    getProduct().then(function (product) {
      if (mounted || !product) return;

      var latestTarget = getInsertionTarget();
      if (!latestTarget || !latestTarget.parent || !latestTarget.reference) return;

      if (latestTarget.form.querySelector('[data-mida-pdp-addon]')) {
        mounted = true;
        return;
      }

      var addon = buildAddon(product);
      if (!addon) return;

      latestTarget.parent.insertBefore(addon, latestTarget.reference);

      hideOtherAddonsAfterMount();
      bindAddonEvents(addon);
      bindSubmitInterceptor(latestTarget.form);
      syncCardVariant(addon.querySelector('[data-pdp-addon-card]'));

      mounted = true;
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    if (target instanceof Element && target.closest('[data-mida-image-close]')) {
      var modal = document.querySelector('[data-mida-image-modal]');
      if (modal) modal.remove();
      document.documentElement.classList.remove('mida-image-modal-open');
      return;
    }

    if (target instanceof Element && target.closest('[data-mida-pdp-addon]')) return;

    document.querySelectorAll('[data-mida-pdp-addon] [data-addon-dropdown].is-open').forEach(function (dropdown) {
      dropdown.classList.remove('is-open');

      var toggle = dropdown.querySelector('[data-addon-dropdown-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target instanceof Element && target.closest('variant-selects')) {
      window.setTimeout(function () {
        document.querySelectorAll('[data-mida-pdp-addon] [data-pdp-addon-card]').forEach(syncCardVariant);
      }, 0);

      window.setTimeout(function () {
        document.querySelectorAll('[data-mida-pdp-addon] [data-pdp-addon-card]').forEach(syncCardVariant);
      }, 150);
    }
  });

  mount();

  var tries = 0;
  var interval = window.setInterval(function () {
    tries += 1;
    mount();

    if (mounted || tries > 40) {
      window.clearInterval(interval);
    }
  }, 250);
})();
